import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
  invoiceId: string;
  hash?: string;
  callback: (success: boolean, code?: string) => void;
}

export interface RequestUserInvoiceAction {
  type: string;
  payload: Fetch;
}

export default function* requestUserInvoice({
  payload,
}: RequestUserInvoiceAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const queryParam = payload.hash ? `?hash=${payload.hash}` : "";
    const response = yield call(
      api.get,
      `/v1/vehicle-debts/internal-payment-receipt/${payload.invoiceId}${queryParam}`,
    );

    const payloadData = Array.isArray(response?.data)
      ? response?.data
      : response?.data?.data;

    if (payloadData) {
      yield call(payload.callback, true, payloadData);
    } else {
      yield call(payload.callback, false, "timeout");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
